import React from "react";
import {toast} from "react-toastify";
import {
  formatToPersianAddComma,
  parseToEnRemoveComma,
} from "../../../utils/CommaSeparator";
import {calculateTotalSum, sumOfPaymentTable} from "../SellFactorFunctionsSadan";

const TitlePriceTaxDiscount = ({
                                 sendData,
                                 setSendData,
                                 initialData,
                                 componentData,
                                 setComponentData,
                               }) => {
  function servicePriceHandler(e) {
    // اینجا باید جمع کل رو هم حساب کنم
    setSendData({servicePrice: parseToEnRemoveComma(e.target.value)});
  }

  function taxHandler(e) {
    const value = parseToEnRemoveComma(e.target.value) | 0;

    if (value < 0) {
      toast("مالیات نمیتواند کمتر از صفر باشد.");
      setSendData({tax: ""});
      return;
    }
    if (value > 100) {
      toast("مالیات نمیتواند بیشتر از صد باشد.");
      setSendData({tax: ""});
      return;
    }
    // اینجا باید جمع کل رو هم حساب کنم
    setSendData({tax: value});
  }

  function discountHandler(e) {
    const discount = parseToEnRemoveComma(e.target.value) | 0;
    const remain =
      calculateTotalSum(sendData) - sumOfPaymentTable(sendData.priceData);

    if (+discount > remain) {
      toast("مبلغ تخفیف نمی تواند بیشتر از  مانده باشد.");
      setSendData({totalDiscount: 0});
      return;
    }

    // اینجا باید جمع کل رو هم حساب کنم
    setSendData({totalDiscount: discount});
  }

  return (
    <>
      {<div className={'divgroup'}>
        <label htmlFor="sendData__serviceTitle">عنوان خدمت</label>
        <input
          id={'sendData__serviceTitle'}
          type="text"
          className="form-control"
          placeholder="عنوان خدمات"
          value={sendData.serviceTitle}
          onChange={(e) =>
            setSendData({serviceTitle: parseToEnRemoveComma(e.target.value)})
          }
        />
      </div>}
      {<>
        {
          <div className={'divgroup'}>
            <label htmlFor="sendData__servicePrice">مبلغ خدمت</label>
            <input
              id={'sendData__servicePrice'}
              type="text"
              className="form-control"
              placeholder="مبلغ خدمات"
              // ref={serviceRef}
              value={
                sendData.servicePrice === "0" ||
                sendData.servicePrice === "" ||
                sendData.servicePrice === 0
                  ? ""
                  : formatToPersianAddComma(sendData.servicePrice)
              }
              onChange={(e) => servicePriceHandler(e)}
            />
          </div>}
      </>}
      <div className="d-flex w-100 mx-0">
        {
          <div className={'divgroup'}>
            <label htmlFor="sendData__tax">مالیات</label>
            <input
              id={'sendData__tax'}
              type="text"
              className="form-control"
              placeholder="درصد مالیات"
              // value={sendData.tax}
              value={                sendData.tax === "" || sendData.tax === 0
                  ? ""
                  : (`مالیات % ` + formatToPersianAddComma(sendData.tax))
              }
              // onChange={(e) => taxHandler(e)}
              disabled={true}
            />
          </div>}
        {<div className={'divgroup'}>
          <label htmlFor="sendData__totalDiscount">تخفیف</label>
          <input
            id={'sendData__totalDiscount'}
            type="text"
            className="form-control mx-1"
            placeholder="تخفیف"
            // value={sendData.totalDiscount}
            value={
              sendData.totalDiscount === "0" || sendData.totalDiscount === 0
                ? ""
                : formatToPersianAddComma(sendData.totalDiscount)
            }
            onChange={(e) => discountHandler(e)}
          />
        </div>
        }
      </div>
    </>
  );
};

export default TitlePriceTaxDiscount;
